// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"d93d3023","754":"c6d06c1e","787":"89576599","828":"94f1e71c"}[chunkId] + ".chunk.js";
};